export const SET_TOKEN_EXPIRED_STATUS = "SET_TOKEN_EXPIRED_STATUS";
export const SET_HYPO_ID = "SET_HYPO_ID";
export const SET_HYPO_NAME = "SET_HYPO_NAME";
export const SET_HYPO_TYPE = "SET_HYPO_TYPE";
export const SET_HYPO_LAST_COMPLETED_STEP = "SET_HYPO_LAST_COMPLETED_STEP";
export const SET_HYPO_CHOSEN_SOURCE = "SET_HYPO_CHOSEN_SOURCE";
export const SET_HYPO_FLOW_MAP = "SET_HYPO_FLOW_MAP";
export const SET_LABELS = "SET_LABELS";
export const SET_ADMIN_TOOL_CONFIG = "SET_ADMIN_TOOL_CONFIG";
export const SET_ASSET_ALLOCATION = "SET_ASSET_ALLOCATION";
export const SET_REPORT_DETAILS_CONFIG = "SET_REPORT_DETAILS_CONFIG";
export const SET_FIRM_SAVED = "SET_FIRM_SAVED";

export const RESET = "RESET";
export const SET_RAW_HYPO_INPUT = "SET_RAW_HYPO_INPUT";

// notifications
export const DISMISS_NOTIFICATION = "DISMISS_NOTIFICATION";
export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const SHOW_NOTIFICATION_STACK = "SHOW_NOTIFICATION_STACK";
export const CLEAR_NOTIFICATION = "CLEAR_NOTIFICATION";
export const CLEAR_NOTIFICATION_STACK = "CLEAR_NOTIFICATION_STACK";
export const CLEAR_STACKED_NOTIFICATION = "CLEAR_STACKED_NOTIFICATION";
export const SET_HYPO_COUNT = "SET_HYPO_COUNT";
export const SET_HYPO_LIST = "SET_HYPO_LIST";

//preference
export const SET_LANGUAGE_ID = "SET_LANGUAGE_ID";
export const SET_CURRENCY = "SET_CURRENCY";
export const SET_TIME_PERIOD = "SET_TIME_PERIOD";
export const SET_BENCHMARK_SETTING = "SET_BENCHMARK_SETTING";
export const SET_ALLOCATE_BY = "SET_ALLOCATE_BY";
export const SET_INITIAL_INVESTMENT_AMOUNT = "SET_INITIAL_INVESTMENT_AMOUNT";
export const SET_REPORT_COVER_PREFERENCE = "SET_REPORT_COVER_PREFERENCE";
export const SET_REPORT_GENERAL_PREFERENCE = "SET_REPORT_GENERAL_PREFERENCE";
export const SET_REPORT_OPTIONS = "SET_REPORT_OPTIONS";
export const SET_TAX_SETTING = "SET_TAX_SETTING";
export const SET_FEE_SETTING = "SET_FEE_SETTING";
export const SET_REBALANCE_SETTING = "SET_REBALANCE_SETTING";
export const SET_REINVESTMENT_SETTING = "SET_REINVESTMENT_SETTING";
export const SET_SUB_SEQUENT_SETTING = "SET_SUB_SEQUENT_SETTING";

// chart
export const SET_CHART_DATA = "SET_CHART_DATA";
export const SET_RELOAD_CHART_DATA = "SET_RELOAD_CHART_DATA";

// investments
export const ADD_PORTFOLIO = "ADD_PORTFOLIO";
export const DELETE_PORTFOLIO = "DELETE_PORTFOLIO";
export const UPDATE_PORTFOLIOLIST = "UPDATE_PORTFOLIOLIST";
export const UPDATE_RAW_PORTFOLIOLIST = "UPDATE_RAW_PORTFOLIOLIST";
export const SET_EDITING_PORTFOLIO_ID = "SET_EDITING_PORTFOLIO_ID";
export const UPDATE_PORTFOLIO_SECURITIES = "UPDATE_PORTFOLIO_SECURITIES";

//generate report
export const SET_STATE_LIST = "SET_STATE_LIST";
export const SET_REPORT_TITLE = "SET_REPORT_TITLE";
export const SET_REPORT_COVER = "SET_REPORT_COVER";
export const SET_REPORT_GENERAL = "SET_REPORT_GENERAL";
export const SET_PREPARED_FOR_FIRST_NAME = "SET_PREPARED_FOR_FIRST_NAME";
export const SET_PREPARED_FOR_LAST_NAME = "SET_PREPARED_FOR_LAST_NAME";
export const SET_PREPARED_FOR_ADDRESS = "SET_PREPARED_FOR_ADDRESS";
export const SET_PREPARED_FOR_CITY = "SET_PREPARED_FOR_CITY";
export const SET_PREPARED_FOR_STATE = "SET_PREPARED_FOR_STATE";
export const SET_PREPARED_FOR_ZIP_CODE = "SET_PREPARED_FOR_ZIP_CODE";
export const SET_PREPARED_FOR_COUNTRY = "SET_PREPARED_FOR_COUNTRY";
export const SET_PREPARED_FOR_PHONE = "SET_PREPARED_FOR_PHONE";
export const SET_PREPARED_FOR_EMAIL = "SET_PREPARED_FOR_EMAIL";
export const SET_PREPARED_BY_FIRST_NAME = "SET_PREPARED_BY_FIRST_NAME";
export const SET_PREPARED_BY_LAST_NAME = "SET_PREPARED_BY_LAST_NAME";
export const SET_PREPARED_BY_ADDRESS = "SET_PREPARED_BY_ADDRESS";
export const SET_PREPARED_BY_CITY = "SET_PREPARED_BY_CITY";
export const SET_PREPARED_BY_STATE = "SET_PREPARED_BY_STATE";
export const SET_PREPARED_BY_ZIP_CODE = "SET_PREPARED_BY_ZIP_CODE";
export const SET_PREPARED_BY_COUNTRY = "SET_PREPARED_BY_COUNTRY";
export const SET_PREPARED_BY_PHONE = "SET_PREPARED_BY_PHONE";
export const SET_PREPARED_BY_EMAIL = "SET_PREPARED_BY_EMAIL";
export const SET_INCLUDE_MF_COMPREHENSIVE = "SET_INCLUDE_MF_COMPREHENSIVE";

// Stepper Mutations
export const SET_CURRENT_FLOW = "SET_CURRENT_FLOW";
export const SET_CURRENT_STEP = "SET_CURRENT_STEP";
export const SET_FLOW_MAP = "SET_FLOW_MAP";
export const SET_PORTFOLIO_WARNING_CLASS = "SET_PORTFOLIO_WARNING_CLASS";
